import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

const { CMS_DATA, CMS_ENV, CMS_COUNTRY, CMS_LOCALE_LANGUAGE, X_CLIENT_HEADER } =
    process.env.REACT_APP_MARKET_VALUES;

export const customerServiceContactNumberApi = createApi({
    reducerPath: 'customerServiceContactNumber',
    baseQuery: fetchBaseQuery({
        baseUrl: CMS_DATA,
        prepareHeaders: (headers) => {
            headers.set('x-client-id', X_CLIENT_HEADER);
            return headers;
        },
    }),
    tagTypes: ['ContactNumber'],
    endpoints: (build) => ({
        getCustomerServiceContactNumber: build.query({
            query: () =>
                CMS_LOCALE_LANGUAGE === null || CMS_LOCALE_LANGUAGE === 'null'
                    ? `?contentType=customerServiceContactNumber&market=${CMS_COUNTRY}&environment=${CMS_ENV}`
                    : `?contentType=customerServiceContactNumber&market=${CMS_COUNTRY}&environment=${CMS_ENV}&locale=${CMS_LOCALE_LANGUAGE}`,
            providesTags: ['ContactNumber'],
        }),
    }),
});
export const { useGetCustomerServiceContactNumberQuery } = customerServiceContactNumberApi;
